import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { CargoPackageVisual } from './CargoVisuals';

const labels = {
  blue: 'Mavi', yellow: 'Sarı', green: 'Yeşil', orange: 'Turuncu',
  purple: 'Mor', box: 'Kutu', envelope: 'Zarf', tube: 'Tüp', bag: 'Poşet',
};
const colors = {
  blue: '#2563EB', yellow: '#FACC15', green: '#22C55E',
  orange: '#FFAE2B', purple: '#9360F1',
};

function GroupValue({ value, isColor }) {
  return (
    <Box sx={{ minWidth: 0, display: 'flex', gap: .35, alignItems: 'center', justifyContent: 'center' }}>
      {isColor
        ? <Box aria-hidden sx={{ width: { xs: 14, sm: 21 }, height: { xs: 14, sm: 21 },
            flexShrink: 0, bgcolor: colors[value] || '#64748B', border: '2px solid rgba(30,20,73,.22)', borderRadius: '50%' }} />
        : <Box sx={{ width: { xs: 21, sm: 28 }, height: { xs: 21, sm: 28 }, flexShrink: 0 }}>
            <CargoPackageVisual color="blue" packageType={value} size="100%" />
          </Box>}
      <Typography component="span" sx={{ fontSize: { xs: 10, sm: 13 }, fontWeight: 900, color: '#493075' }}>
        {labels[value] || value}
      </Typography>
    </Box>
  );
}

export default function CargoGroupRuleCard({ rule, compact = false }) {
  const isColor = rule?.rule_type === 'color';
  return (
    <Box
      data-testid="cargo-group-rule-card"
      role="region"
      aria-label={isColor ? 'Renge göre gruplama' : 'Paket türüne göre gruplama'}
      sx={{
        width: '100%', borderRadius: 3, border: '2px solid #D8CCFF',
        bgcolor: '#fff', boxShadow: '0 4px 0 rgba(91,33,182,.10)',
        px: { xs: .65, sm: 1.2 }, py: compact ? .65 : { xs: 1, sm: 1.3 },
      }}
    >
      <Typography sx={{ color: '#6D28D9', fontWeight: 1000, textAlign: 'center',
        fontSize: compact ? { xs: 10, sm: 12 } : { xs: 12, sm: 15 }, mb: .65 }}>
        {isColor ? 'RENGE GÖRE AYIR' : 'PAKET TÜRÜNE GÖRE AYIR'}
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)', gap: { xs: .65, sm: 1.2 } }}>
        {['left', 'right'].map(side => (
          <Box key={side} sx={{ minWidth: 0, border: '2px solid #E7DDFB', borderRadius: 2.5,
            bgcolor: '#F8F5FF', py: compact ? .5 : 1, px: .4 }}>
            <Typography sx={{ textAlign: 'center', fontWeight: 1000, color: '#5B21B6', fontSize: { xs: 11, sm: 14 }, mb: .5 }}>
              {side === 'left' ? 'SOL' : 'SAĞ'}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center',
              justifyContent: 'center', gap: { xs: .55, sm: .9 }, minHeight: compact ? 32 : 42 }}>
              {rule.groups[side].map(value => <GroupValue key={value} value={value} isColor={isColor} />)}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
